import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import Grow from "@material-ui/core/Grow";
import { HashLink } from "react-router-hash-link";

import $ from "jquery";
import { I18nProvider } from "../i18n";
import translate from "../i18n/translate";
import { settings } from '../settings'
import "./CircleModals.css";

import "./svg/CourbeAbout.css";

const useStyles = (isMobile) =>
    makeStyles(() => ({
        card: {
            width: isMobile ? "90vw" : "75vw",
            height: isMobile ? "60vh" : "75vh",
            borderRadius: "4px",
            padding: "20px",
            justifySelf: "flex-end",
            boxShadow: "0 12px 25px 0 rgb(199 175 189 / 25%)",
            display: 'flex'
        },
        description: {
            width: '55%'
        },
        separator: {
            display: isMobile ? "none" : "flex",
            height: '95%',
            width: '5px',
            backgroundColor: 'rgba(0, 0, 0, 0.95)',
            borderRadius: '4px',
            alignSelf: 'center',
            margin: '0 15px 0 15px'
        },
        projects: {
            display: isMobile ? "none" : "flex",
            justifyContent: 'center',
            alignItems: 'center',
            width: '50%'
        },
        modal: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
        },
        image: {
            height: "auto",
            width: '30vmin',
        },
        text: {
            color: "white",
            margin: "30px",
            marginLeft: "30px",
            marginRight: "40px",
        },
        link: {
            width: '75%',
            height: '100%',
        },
        galleryExps: {
            height: '100%',
            width: '100%',
        }
    }));

export default function AllModals({
    isMobile,
    locale,
    selectedExp,
    openExpModal,
    handleCloseExpModal,
    setSelectedGallerySrc
}) {
    const classes = useStyles(isMobile)();

    let durationMonth = 0;
    let durationYear = 0;
    let sYear = selectedExp.yearStart;
    let eYear = selectedExp.yearEnd;
    let sMonth = selectedExp.monthStart;
    let eMonth = selectedExp.monthEnd;

    let gallery = [...settings.creationsArray].filter(x => x.expsid === selectedExp.id);

    if (!eYear) {
        eYear = new Date().getFullYear();
        eMonth = new Date().getMonth() + 1;
        console.log(eYear, eMonth)
    }
    while (sYear < eYear) {
        sMonth++;
        durationMonth++
        if (sMonth === 12) {
            sMonth = 0;
            sYear++;
        }
    }
    while (sMonth < eMonth) {
        sMonth++;
        durationMonth++
    }
    while (durationMonth >= 12) {
        durationYear++
        durationMonth -= 12;
    }
    durationMonth = (durationMonth <= 2 && durationYear > 1) ? 0 : durationMonth;
    if (durationMonth >= 10) { durationMonth = 0; durationYear++ };


    useEffect(() => {
        setTimeout(() => {
            $("#galleryExps").on("click", function (e) {
                if (e.target.src !== undefined) {
                    setSelectedGallerySrc(`creations-gallery/${e.target.src.split("/").pop()}`);
                    handleCloseExpModal()
                }
            });
        }, 100)
    })

    return (
        <div>
            <Modal className={classes.modal} open={openExpModal} onClose={handleCloseExpModal}>
                <Grow in={openExpModal}>
                    <Card className={classes.card}>
                        <CardContent className={classes.description}>
                            <div className="d-flex flex-row">
                                <div>
                                    <Typography variant="h4" component="h2">
                                        <I18nProvider locale={locale}>
                                            {translate(selectedExp.modalTitle)}
                                        </I18nProvider>
                                    </Typography>
                                    <Typography variant="none" component="h4">
                                        {
                                            durationYear > 0 &&
                                            <I18nProvider locale={locale}>
                                                {durationYear} {translate('year')}
                                            </I18nProvider>
                                        }
                                        {
                                            durationMonth !== 0 &&
                                            durationYear !== 0 &&
                                            <I18nProvider locale={locale}> {translate('and')} </I18nProvider>
                                        }
                                        {
                                            durationMonth !== 0 &&
                                            <I18nProvider locale={locale}>
                                                {durationMonth} {translate('month')}
                                            </I18nProvider>
                                        }
                                        <span> | </span>
                                        {
                                            selectedExp.monthStart &&
                                            <I18nProvider locale={locale}>
                                                <span>{translate('month' + selectedExp.monthStart)} </span>
                                            </I18nProvider>
                                        }
                                        <span>{selectedExp.yearStart} </span>
                                        {
                                            selectedExp.yearEnd &&
                                            <>
                                                -
                                                {
                                                    selectedExp.monthEnd &&
                                                    <I18nProvider locale={locale}>
                                                        <span> {translate('month' + selectedExp.monthEnd)} </span>
                                                    </I18nProvider>
                                                }
                                                {selectedExp.yearEnd}
                                            </>
                                        }

                                    </Typography>
                                </div>
                            </div>

                            <Typography variant="body2" color="textSecondary" component="p" className="mt-2">
                                <I18nProvider locale={locale}>
                                    {translate(selectedExp.modalDesc)}
                                </I18nProvider>
                            </Typography>
                            {
                                selectedExp.skills.length > 0 &&
                                <>
                                    <Typography variant="" color="textSecondary" component="h4" className="mt-2">
                                        <I18nProvider locale={locale}>
                                            {translate("exps")}
                                        </I18nProvider>
                                    </Typography>
                                    <ul> {
                                        selectedExp.skills.map((skill, i) =>
                                            <li>{skill}</li>
                                        )
                                    }
                                    </ul>
                                </>
                            }
                        </CardContent>
                        <span className={classes.separator}></span>
                        <CardContent className={classes.projects}>
                            {
                                gallery.length > 0 ?
                                    <HashLink
                                        className={classes.link}
                                        to="/Portfolio#creations"
                                    >
                                        <div id="galleryExps" className={classes.galleryExps}>
                                            <div className="group">
                                                {gallery.map((item, i) => (
                                                    <img className="card" alt="Illustration d'un projet" src={item.src}></img>
                                                ))}
                                            </div>
                                            <div aria-hidden className="group">
                                                {gallery.map((item, i) => (
                                                    <img className="card" alt="Illustration d'un projet" src={item.src}></img>
                                                ))}
                                            </div>
                                        </div>
                                    </HashLink> :

                                    <Typography variant="body2" color="textSecondary" component="p">
                                        <I18nProvider locale={locale}>
                                            {translate('noProjects')}
                                        </I18nProvider>
                                    </Typography>
                            }
                        </CardContent>
                    </Card>
                </Grow>
            </Modal>
        </div>
    );
}
